import { useEffect } from 'react'
import { isEmpty } from 'lodash'

export function usePlanMatchesEffect({
  participantsForSubmission,
  fetchPlanMatches,
  productType,
  setError,
}) {
  useEffect(() => {
    async function getPlanMatches() {
      try {
        if (!isEmpty(participantsForSubmission)) {
          const plans = participantsForSubmission.map(
            ({ planName, planEin }) => ({
              planName,
              ein: planEin || '',
            })
          )
          await fetchPlanMatches(productType, plans)
        }
      } catch {
        setError(true)
      }
    }
    getPlanMatches()
  }, [participantsForSubmission, fetchPlanMatches])
}
